import React from 'react';
import './NewsSection.css';

const newsData = [
  {
    icon: '📰',
    title: '公司新闻',
    items: [
      'AuditAI荣获2024年度最佳创新企业奖',
      '发布新一代AI审计平台2.0',
      '与全球500强企业达成战略合作',
    ],
  },
  {
    icon: '📈',
    title: '行业洞察',
    items: [
      '2024年AI审计发展趋势报告',
      '企业数字化转型白皮书',
      '智能风控解决方案解析',
    ],
  },
  {
    icon: '💬',
    title: '技术博客',
    items: [
      '如何用AI识别财务造假?',
      '区块链技术在审计中的应用',
      '数据治理最佳实践分享',
    ],
  },
];

const NewsSection: React.FC = () => (
  <section className="news-section">
    <h2>最新动态</h2>
    <div className="news-list">
      {newsData.map((news, idx) => (
        <div className="news-card" key={idx}>
          <div className="news-icon">{news.icon}</div>
          <h3>{news.title}</h3>
          <ul>
            {news.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </section>
);

export default NewsSection; 